import React from "react";
import { Box, Skeleton } from "@mui/material";

const NotificationSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: "5%",
        bgcolor: "#FFFFFF",
        transition: "transform 0.2s",
        boxShadow: "0px 10px 20px 0px #0000000A",
        border: "1px solid #D9D9D9",
      }}
    >
      <Box sx={{ width: "1%" }}>
        {/* Status Dot Placeholder */}
        <Skeleton
          variant="circular"
          width={8}
          height={8}
          sx={{ visibility: "hidden" }}
        />
      </Box>

      <Box sx={{ width: "12%" }}>
        <Skeleton
          variant="rectangular"
          sx={{
            width: { xs: "11.65vw", sm: "24px" },
            height: { xs: "11.65vw", sm: "24px" },
            borderRadius: "12px",
          }}
        />
      </Box>

      <Box sx={{ width: "70%" }}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: { xs: "3.88vw", sm: "16px" },
            width: "60%",
          }}
        />
        <Skeleton
          variant="text"
          sx={{
            fontSize: { xs: "2.91vw", sm: "14px" },
            width: "90%",
          }}
        />
        <Skeleton
          variant="text"
          sx={{
            fontSize: { xs: "2.91vw", sm: "14px" },
            width: "40%",
          }}
        />
      </Box>

      <Box sx={{ width: "5%" }}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: { xs: "2.91vw", sm: "12px" },
            width: "100%",
          }}
        />
      </Box>
    </Box>
  );
};

export default NotificationSkeleton;
